import { globalGetService } from '@/utils/globalApiServices';
import { Channel, Mno, UsecaseType, VerticalType } from './types';

export const getCountries = async () => {
  const response = await globalGetService('enums/countries');
  return (response?.ok ? response.data : {}) as Record<string, string>;
};

export const getUsecaseTypes = async (params?: {
  countryCode?: string;
  channelId?: Channel;
  validSubUsecase?: boolean;
}) => {
  const response = await globalGetService('enums/usecaseTypes', params);
  return (response?.ok ? response.data : []) as UsecaseType[];
};

export const getBillingCategories = async () => {
  const response = await globalGetService('enums/billingCategory');
  return response?.ok ? (response.data as string[]) : [];
};

export const getVerticalTypes = async () => {
  const response = await globalGetService('enums/verticalTypes');
  return (response?.ok ? response.data : []) as VerticalType[];
};

export const getIdentityStatus = async () => {
  const response = await globalGetService('enums/brandIdentityStatus');
  return response?.ok ? response.data : [];
};

export const getLoaStatus = async () => {
  const response = await globalGetService('enums/loaStatus');
  return response?.ok ? response.data : [];
};

export const getTrademarkStatus = async () => {
  const response = await globalGetService('enums/tmVerificationStatus');
  return response?.ok ? response.data : [];
};

export const getEventTypes = async () => {
  const response = await globalGetService('enums/eventTypes');
  return response?.ok ? response.data : [];
};

export const getMnos = async () => {
  const response = await globalGetService('enums/mnoByCountry');
  return (response?.ok ? response.data : []) as Mno[];
};
